module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/152/assets/images/e6f704237fad58d55a84c0ef7b05876c.svg";


//////////////////
// WEBPACK FOOTER
// ./components/toast/assets/close-icon.svg
// module id = Qy98
// module chunks = 1